import type { SourceImage } from "@brickme/frontend-common/src/source-image/source-image.ts";
import { getCurrentScope } from "@sentry/react";

const modeKey = "mode";
const codeKey = "code";
const numberOfKitsKey = "numberOfKits";
const sourceImageKey = "sourceImage";
const instructionDestinationKey = "instructionsDestination";

function setScopeExtra(name: string, value: unknown) {
	getCurrentScope().setExtra(name, value);
}

const sentryLogExtra = {
	setMode(mode: string) {
		setScopeExtra(modeKey, mode);
		getCurrentScope().setExtras({
			[codeKey]: null,
			[numberOfKitsKey]: null,
			[sourceImageKey]: null,
		});
	},
	setCode(code: string) {
		setScopeExtra(codeKey, code);
	},
	setNumberOfKits(numberOfKits: number) {
		setScopeExtra(numberOfKitsKey, numberOfKits);
	},
	setSourceImage({ bitmap, contentType, fileName }: SourceImage) {
		setScopeExtra(sourceImageKey, {
			bitmap: {
				width: bitmap.width,
				height: bitmap.height,
			},
			contentType,
			fileName,
		});
	},
	setSourceImageConfirmed(
		{ bitmap, contentType, fileName }: SourceImage,
		rotation: number,
	) {
		setScopeExtra(sourceImageKey, {
			bitmap: {
				width: bitmap.width,
				height: bitmap.height,
			},
			contentType,
			fileName,
			rotation,
		});
	},
	setInstructionsDestination(destination: { name: string; email: string }) {
		setScopeExtra(instructionDestinationKey, destination);
	},
};

export { sentryLogExtra };
